
import { Routes } from '@angular/router';
import { subscriptionManagementRoutes } from './subscription-management/subscription-routing-model';
import { SubscriptionManagementComponent } from './subscription-management/subscription-management.component';
import { ProfileComponent } from '../profile/profile.component';
import { UserManualComponent } from '../../user-manual/user-manual.component';
import { userManualRoutes } from '../../user-manual/user-manual-routing-module';
import { groupManagementRoutes } from '../admin/institution-management/group-management/group-management-routing.module';
import {FaqsComponent} from '../../faqs/faqs.component';

export const userAccountRoutes: Routes = [
  { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
  {
    path: 'dashboard',
    loadComponent: () =>
      import(
        '../../meetings-management/meetings-management-dashboard/meetings-management-dashboard.component'
      ).then((m) => m.MeetingsManagementDashboardComponent),
  },
  {
    path: 'meetings-portal',
    loadComponent: () =>
      import(
        '../../meetings-management/meetings-portal/meetings-portal.component'
      ).then((m) => m.MeetingsPortalComponent),
  },
  {
    path: 'manage-meeting/:id',
    loadComponent: () =>
      import(
        '../../meetings-management/manage-meeting/manage-meeting.component'
      ).then((m) => m.ManageMeetingComponent),
  },
  {
    path: 'manage-subscription',
    component: SubscriptionManagementComponent,
    children: [...subscriptionManagementRoutes],
  },
  {
    path: 'plan-and-pricing',
    loadComponent: () =>
      import(
        '../../plan-pricing-management/plan-pricing-management.component'
      ).then((m) => m.PlanPricingManagementComponent),
  },
  {
    path: 'payment-and-billing',
    loadComponent: () =>
      import('../../payment-billing/payment-billing.component').then(
        (m) => m.PaymentBillingComponent
      ),
  },
  {
    path: 'user-manual',
    component: UserManualComponent,
    children: [...userManualRoutes],
  },
  {
    path: 'faqs',
    component: FaqsComponent,
  },
   {
    path: 'my-profile',
    loadComponent: () =>
      import('../profile/profile.component').then(
        (m) => m.ProfileComponent
      ),
  },
//   {
//   path: 'notifications',
//   loadComponent: () =>
//     import(
//       ''
//     ).then((m) => m.NotificationListComponent),
// },

  {
    path: 'feedback',
    loadComponent: () =>
      import('../../feedback/feedback.component').then(
        (m) => m.FeedbackComponent
      ),
  },
  {
    path: 'user-manual',
    loadComponent: () =>
      import('../../user-manual/user-manual.component').then(
        (m) => m.UserManualComponent
      )
  },
  {
    path: 'help-desk',
    loadComponent: () =>
      import('../../help-desk/help-desk.component').then(
        (m) => m.HelpDeskComponent
      ),
  },
  {
    path: 'calendar',
    loadComponent: () =>
      import(
        '../../../shared/components/events-calendar/events-calendar.component'
      ).then((m) => m.EventsCalendarComponent),
  },
  {
    path: 'my-organization/:id',
    loadComponent: () =>
      import(
        '../admin/institution-management/view-institution/view-institution.component'
      ).then((m) => m.ViewInstitutionComponent),
    data : {
      accountTypeRestriction : 'ORGANIZATION'
    }
  },
  {
    path: 'group/:id',
    loadComponent: () =>
      import('../admin/institution-management/group-management/view-group/view-group.component').then(
        (m) => m.ViewGroupComponent,
      ),
    children: [...groupManagementRoutes],
  },
];
